<div class="container">
  <mat-card>
    <form [formGroup]="chargeForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Charge Applies To' | translate }}</mat-label>
            <mat-select required formControlName="chargeAppliesTo">
              @for (chargeAppliesTo of chargesTemplateData.chargeAppliesToOptions; track chargeAppliesTo) {
                <mat-option [value]="chargeAppliesTo.id">
                  {{ chargeAppliesTo.value | translateKey: 'catalogs' }}
                </mat-option>
              }
            </mat-select>
            @if (chargeForm.controls.chargeAppliesTo.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Charge Applies To' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-divider [inset]="true"></mat-divider>

          @if (chargeForm.controls.chargeAppliesTo.value) {
            <div class="layout-row-wrap gap-2percent layout-lt-md-column form-section">
              <mat-form-field class="flex-48">
                <mat-label>{{ 'labels.inputs.Charge Name' | translate }}</mat-label>
                <input matInput required formControlName="name" />
                @if (chargeForm.controls.name.hasError('required')) {
                  <mat-error>
                    {{ 'labels.inputs.Charge Name' | translate }} {{ 'labels.commons.is' | translate }}
                    <strong>{{ 'labels.commons.required' | translate }}</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-48">
                <mat-label>{{ 'labels.inputs.Currency' | translate }}</mat-label>
                <mat-select required formControlName="currencyCode">
                  @for (currency of chargesTemplateData.currencyOptions; track currency) {
                    <mat-option [value]="currency.code">
                      {{ currency.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (chargeForm.controls.currencyCode.hasError('required')) {
                  <mat-error>
                    {{ 'labels.inputs.Currency' | translate }} {{ 'labels.commons.is' | translate }}
                    <strong>{{ 'labels.commons.required' | translate }}</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-48">
                <mat-label>{{ 'labels.inputs.Charge Time Type' | translate }}</mat-label>
                <mat-select required formControlName="chargeTimeType">
                  @for (chargeTimeType of chargeTimeTypeData; track chargeTimeType) {
                    <mat-option [value]="chargeTimeType.id">
                      {{ chargeTimeType.value | translateKey: 'catalogs' }}
                    </mat-option>
                  }
                </mat-select>
                @if (chargeForm.controls.chargeTimeType.hasError('required')) {
                  <mat-error>
                    {{ 'labels.inputs.Charge Time Type' | translate }} {{ 'labels.commons.is' | translate }}
                    <strong>{{ 'labels.commons.required' | translate }}</strong>
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="flex-48">
                <mat-label>{{ 'labels.inputs.Charge Calculation Type' | translate }}</mat-label>
                <mat-select required formControlName="chargeCalculationType">
                  @for (chargeCalculationType of filteredChargeCalculationType(); track chargeCalculationType) {
                    <mat-option [value]="chargeCalculationType.id">
                      {{ chargeCalculationType.value | translateKey: 'catalogs' }}
                    </mat-option>
                  }
                </mat-select>
                @if (chargeForm.controls.chargeCalculationType.hasError('required')) {
                  <mat-error>
                    {{ 'labels.inputs.Charge Calculation Type' | translate }} {{ 'labels.commons.is' | translate }}
                    <strong>{{ 'labels.commons.required' | translate }}</strong>
                  </mat-error>
                }
              </mat-form-field>
              @if (chargeForm.controls.chargeAppliesTo.value === 1) {
                <mat-form-field class="flex-48">
                  <mat-label>{{ 'labels.inputs.Charge Payment Mode' | translate }}</mat-label>
                  <mat-select required formControlName="chargePaymentMode">
                    @for (chargePaymentMode of chargesTemplateData.chargePaymetModeOptions; track chargePaymentMode) {
                      <mat-option [value]="chargePaymentMode.id">
                        {{ chargePaymentMode.value | translateKey: 'catalogs' }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (chargeForm.controls.chargePaymentMode.hasError('required')) {
                    <mat-error>
                      {{ 'labels.inputs.Charge Payment Mode' | translate }} {{ 'labels.commons.is' | translate }}
                      <strong>{{ 'labels.commons.required' | translate }}</strong>
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (chargeForm.controls.chargeTimeType.value === 9) {
                <div class="flex-48 add-fee-frequency-wrapper">
                  <mat-checkbox labelPosition="before" formControlName="addFeeFrequency">
                    {{ 'labels.inputs.Add Fee Frequency' | translate }}
                  </mat-checkbox>
                </div>
              }
              @if (chargeForm.controls.chargeTimeType.value === 9 && chargeForm.controls.addFeeFrequency.value) {
                <mat-form-field class="flex-48">
                  <mat-label>{{ 'labels.inputs.Frequency Interval' | translate }}</mat-label>
                  <input matInput required formControlName="feeInterval" />
                  @if (chargeForm.controls.feeInterval.hasError('required')) {
                    <mat-error>
                      {{ 'labels.inputs.Frequency Interval' | translate }} {{ 'labels.commons.is' | translate }}
                      <strong>{{ 'labels.commons.required' | translate }}</strong>
                    </mat-error>
                  }
                  @if (chargeForm.controls.feeInterval.hasError('pattern')) {
                    <mat-error>
                      {{ 'labels.inputs.Frequency Interval' | translate }}
                      <strong>{{ 'labels.commons.must be a positive integer' | translate }}</strong>
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (chargeForm.controls.chargeTimeType.value === 9 && chargeForm.controls.addFeeFrequency.value) {
                <mat-form-field class="flex-48">
                  <mat-label>{{ 'labels.inputs.Charge Frequency' | translate }}</mat-label>
                  <mat-select required formControlName="feeFrequency">
                    @for (feeFrequency of chargesTemplateData.feeFrequencyOptions; track feeFrequency) {
                      <mat-option [value]="feeFrequency.id">
                        {{ feeFrequency.value | translateKey: 'catalogs' }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (chargeForm.controls.feeFrequency.hasError('required')) {
                    <mat-error>
                      {{ 'labels.inputs.Charge Frequency' | translate }} {{ 'labels.commons.is' | translate }}
                      <strong>{{ 'labels.commons.required' | translate }}</strong>
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (chargeForm.controls.chargeTimeType.value === 6 || chargeForm.controls.chargeTimeType.value === 7) {
                <mat-form-field (click)="dueDatePicker.open()" class="flex-48">
                  <mat-label>{{ 'labels.inputs.Due Date' | translate }}</mat-label>
                  <input
                    matInput
                    [min]="minDate"
                    [max]="maxDate"
                    [matDatepicker]="dueDatePicker"
                    required
                    formControlName="feeOnMonthDay"
                  />
                  <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #dueDatePicker></mat-datepicker>
                  @if (chargeForm.controls.feeOnMonthDay.hasError('required')) {
                    <mat-error>
                      {{ 'labels.inputs.Due Date' | translate }} {{ 'labels.commons.is' | translate }}
                      <strong>{{ 'labels.commons.required' | translate }}</strong>
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (chargeForm.controls.chargeTimeType.value === 7 || chargeForm.controls.chargeTimeType.value === 11) {
                <mat-form-field class="flex-48">
                  <mat-label>{{ 'labels.inputs.Repeat Every' | translate }} ({{ repeatEveryLabel }})</mat-label>
                  <input matInput required formControlName="feeInterval" />
                  @if (chargeForm.controls.feeInterval.hasError('required')) {
                    <mat-error>
                      {{ 'labels.inputs.Repeat Every' | translate }} ({{ repeatEveryLabel }})
                      {{ 'labels.commons.is' | translate }} <strong>{{ 'labels.commons.required' | translate }}</strong>
                    </mat-error>
                  }
                  @if (
                    (chargeForm.controls.feeInterval.hasError('min') ||
                      chargeForm.controls.feeInterval.hasError('max')) &&
                    !chargeForm.controls.feeInterval.hasError('pattern')
                  ) {
                    <mat-error>
                      {{ 'labels.inputs.Repeat Every' | translate }} ({{ repeatEveryLabel }})
                      <strong>{{ 'labels.commons.must be between 1 and 12' | translate }}</strong>
                    </mat-error>
                  }
                  @if (chargeForm.controls.feeInterval.hasError('pattern')) {
                    <mat-error>
                      {{ 'labels.inputs.Repeat Every' | translate }} ({{ repeatEveryLabel }})
                      <strong>{{ 'labels.commons.must be a positive integer' | translate }}</strong>
                    </mat-error>
                  }
                </mat-form-field>
              }
              <mat-form-field class="flex-48">
                <mat-label>{{ 'labels.inputs.Amount' | translate }}</mat-label>
                <input matInput required formControlName="amount" />
                @if (chargeForm.controls.amount.hasError('required')) {
                  <mat-error>
                    {{ 'labels.inputs.Amount' | translate }} {{ 'labels.commons.is' | translate }}
                    <strong>{{ 'labels.commons.required' | translate }}</strong>
                  </mat-error>
                }
              </mat-form-field>
              <!--
              * minCap and maxCap only allowed for loan ,shares and savings entitites
              * In Loan case: Only for the "charge calculation type" set as "%amount", "% loan amount+interest", "%interest",and"%disbursement amount".
              * In saving case: Only for 1. charge time type is "withdrawlfee" or "savings no activity fee" with charge calculation type as "% amount"
              * In shares case: Only for charge time type: SHARE_PURCHASE and SHARE_REDEEM and with charge calculation type as % amount only
              -->
              @if (showMinMaxCap()) {
                <mat-form-field class="flex-48">
                  <mat-label>{{ 'labels.inputs.Minimum Charge Cap' | translate }}</mat-label>
                  <input matInput autofocus formControlName="minCap" LOSxValidateOnFocus />
                  @if (chargeForm.controls.minCap.hasError('maxValue')) {
                    <mat-error>
                      {{ 'errors.validation.msg.loanproduct.minimumGap.not.greater.than.specified.number' | translate }}
                      ({{ chargeForm.controls.maxCap.value }})
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (showMinMaxCap()) {
                <mat-form-field class="flex-48">
                  <mat-label>{{ 'labels.inputs.Maximum Charge Cap' | translate }}</mat-label>
                  <input matInput autofocus formControlName="maxCap" LOSxValidateOnFocus />
                  @if (chargeForm.controls.maxCap.hasError('minValue')) {
                    <mat-error>
                      {{ 'errors.validation.msg.loanproduct.maximumGap.not.greater.than.specified.number' | translate }}
                      ({{ chargeForm.controls.minCap.value }})
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (chargeForm.controls.chargeAppliesTo.value === 3) {
                <LOSx-gl-account-selector
                  class="flex-48"
                  [inputFormControl]="chargeForm.controls.incomeAccountId"
                  [glAccountList]="incomeAndLiabilityAccountData"
                  [inputLabel]="'Income from Charge'"
                >
                </LOSx-gl-account-selector>
              }
              <mat-form-field class="flex-48">
                <mat-label>{{ 'labels.inputs.Tax Group' | translate }}</mat-label>
                <mat-select formControlName="taxGroupId">
                  @for (taxGroup of chargesTemplateData.taxGroupOptions; track taxGroup) {
                    <mat-option [value]="taxGroup.id">
                      {{ taxGroup.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="flex-48 layout-row gap-2percent layout-lt-md-column">
                <div class="flex-50 active-wrapper">
                  <mat-checkbox labelPosition="before" formControlName="active">
                    {{ 'labels.status.Active' | translate }}
                  </mat-checkbox>
                </div>
                <div class="flex-50 penalty-wrapper">
                  <mat-checkbox labelPosition="before" formControlName="penalty">
                    {{ 'labels.commons.Is' | translate }} {{ 'labels.inputs.Penalty' | translate }}
                  </mat-checkbox>
                </div>
              </div>
            </div>
          }
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!chargeForm.valid" *LOSxHasPermission="'CREATE_CHARGE'">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
